var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.739931 9.27991C0.549931 9.27991 0.359932 9.20991 0.209932 9.05991C-0.0800683 8.76991 -0.0800683 8.28991 0.209932 7.99991L3.20993 4.99991L0.209932 1.99991C-0.0800683 1.70991 -0.0800683 1.22991 0.209932 0.939912C0.499932 0.649912 0.979932 0.649912 1.26993 0.939912L4.79993 4.46991C5.08993 4.75991 5.08993 5.23991 4.79993 5.52991L1.26993 9.05991C1.11993 9.20991 0.929931 9.27991 0.739931 9.27991Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandRightIcon);
export default __webpack_public_path__ + "static/media/expand-right-icon.0033b78e4852f4b4ea1a7d2b2004abb0.svg";
export { ForwardRef as ReactComponent };